import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { ellipsisMultiline } from '@/styles/helpers';
import { CustomLink } from '@/components/CustomLink/CustomLink';

export const Card = styled(CustomLink)`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 21px;
  border: 1px solid ${({ theme }) => theme.palette.primary.border};
  background: ${({ theme }) => theme.palette.secondary.background};
  box-shadow: 0 1px 3px ${({ theme }) => theme.palette.overlay[8]};
  text-decoration: none;
  color: inherit;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;

  &:hover {
    box-shadow: 0 4px 12px ${({ theme }) => theme.palette.overlay[8]};
    border-color: ${({ theme }) => theme.palette.secondary.border};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px;
    box-shadow: 0 2px 8px ${({ theme }) => theme.palette.overlay[8]};
  }
`;

export const TopRow = styled.div`
  display: grid;
  grid-template-columns: 65px 1fr;
  gap: 12px;
  align-items: center;
  min-height: 65px;
`;

export const LogoWrapper = styled.div`
  width: 65px;
  height: 65px;
  flex-shrink: 0;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.palette.primary.border};
  background: ${({ theme }) => theme.palette.secondary.background};
`;

export const Logo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const Info = styled.div`
  min-width: 0;
`;

export const Title = styled(Typography.Title)`
  color: ${({ theme }) => theme.palette.primary.labels};
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.25;
  ${ellipsisMultiline(2)}
`;

export const Description = styled(Typography.Body)`
  ${ellipsisMultiline(2)}
  color: ${({ theme }) => theme.palette.secondary.labels};
  margin: 0;
  font-size: 13px;
  line-height: 1.3;
`;

export const Count = styled(Typography.Body)`
  margin-top: 4px;
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 14px;
  font-weight: 400;
`;

export const CountLink = styled.span`
  color: ${({ theme }) => theme.palette.primary.labels};
  text-decoration: underline;
  text-underline-offset: 2px;
  transition: color 0.15s ease;

  &:hover {
    color: ${({ theme }) => theme.palette.brand.main};
  }
`;

export const TimeOnPlatform = styled.span`
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
`;

export const ButtonsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 18px;
`;

export const PhonesWrap = styled.div`
  position: relative;
  flex: 1;
`;

export const SubscribeButton = styled.button<{ $isFavorited?: boolean }>`
  flex: 1;
  padding: 10px 0;
  border-radius: 12px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  background: ${({ theme, $isFavorited }) =>
    $isFavorited ? theme.palette.system.white : theme.palette.system.lightBlue};
  color: ${({ theme }) => theme.palette.primary.labels};
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.9;
  }
`;

export const ShowNumberButton = styled.button`
  flex: 1;
  padding: 10px 0;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
  font-size: 14px;
  font-weight: 500;
  display: block;
  width: 100%;
  text-align: center;
  height: 40px;
  max-height: 40px;
  cursor: pointer;
  background: ${({ theme }) => theme.palette.system.white};
  color: ${({ theme }) => theme.palette.primary.labels};
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.9;
  }
`;

export const PhonePopup = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  left: auto;
  min-width: 290px;
  width: max-content;
  background: ${({ theme }) => theme.palette.primary.background};
  border-radius: 12px;
  padding: 10px 0;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 20;
`;

export const PhoneItem = styled.a`
  display: flex;
  align-items: center;
  justify-content: left;
  background-image: url('/images/shops/phone.svg');
  background-repeat: no-repeat;
  background-position: 15px center;
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 16px;
  font-weight: 500;
  padding: 10px 10px 10px 40px;
  text-decoration: none;

  &:hover {
    background-color: ${({ theme }) => theme.palette.secondary.background};
  }
`;
